import {decorate, observable} from 'mobx';
import {BaseModel} from './base';
import {CustomPropertyTypes} from './customProperty';
import i18n from '../i18n/i18n';
import {transformation} from '../utils/transformations';
import {displayableProperty} from './displayableProperty';
import {displayablePropertyParam} from './displayablePropertyParam';
import {Material} from './material';

export class Component extends BaseModel {
  customPropertyType = CustomPropertyTypes.Component;

  displayableProperties = [
    displayableProperty({
      title: i18n.t('component.model.attributes.no'),
      params: [displayablePropertyParam({path: 'no', transform: transformation.none})],
      template: '{value}',
      key: 'no',
    }),
    displayableProperty({
      title: i18n.t('component.model.attributes.quantity'),
      params: [displayablePropertyParam({path: 'plannedQuantity', transform: transformation.none})],
      template: '{value}',
      key: 'plannedQuantity',
    }),
    displayableProperty({
      title: i18n.t('component.model.attributes.info'),
      params: [displayablePropertyParam({path: 'info', transform: transformation.none})],
      template: '{value}',
      key: 'info',
    }),
    displayableProperty({
      title: i18n.t('component.model.attributes.actualQuantity'),
      params: [displayablePropertyParam({path: 'actualQuantity', transform: (v) => (v === null ? 0 : v)})],
      template: '{value}',
      key: 'actualQuantity',
    }),
    displayableProperty({
      title: i18n.t('component.model.attributes.unitOfMeasure'),
      params: [displayablePropertyParam({path: 'unitOfMeasure.label', transform: transformation.none})],
      template: '{value}',
      key: 'unitOfMeasure',
    }),
  ];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.material = rootStore.materialStore.getById(this.materialId);
    this.unitOfMeasure = rootStore.unitOfMeasurementStore.getById(this.unitOfMeasureId);
  }

  static allDisplayableProperties(rootStore, pathPrefix = '', titlePrefix = '') {
    const allDisplayableProperties = super.allDisplayableProperties(rootStore, pathPrefix, titlePrefix);
    allDisplayableProperties.push(
      ...this.displayableCustomProperties(rootStore, CustomPropertyTypes.Component, pathPrefix, titlePrefix)
    );

    allDisplayableProperties.push(
      ...Material.allDisplayableProperties(rootStore, `${pathPrefix}material.`, titlePrefix)
    );

    return allDisplayableProperties;
  }
}

decorate(Component, {
  id: observable,
  no: observable,
  info: observable,
  position: observable,
  operationId: observable,
  operation: observable,
  material: observable,
  materialId: observable,
  unitOfMeasure: observable,
  unitOfMeasureId: observable,
  plannedQuantity: observable,
  actualQuantity: observable,
  isRetrograde: observable,
  toleranceLow: observable,
  toleranceHigh: observable,
  preparationQuantity: observable,
  preparedQuantity: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
